import { IconName } from "@fortawesome/fontawesome-svg-core";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Alert, CreateModal, MenuOptions } from "@mikros/shared-ui";
import { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import { CourseCard } from "./courseCard";
import ApiServices from "../../service/apiService";
import { AllCourses, CoursesRecieved } from "@mikros/library";
import {
  InputClearValue,
  TextBox,
  TextBoxChangeEvent,
} from "@progress/kendo-react-inputs";
import { FormattedMessage, useIntl } from "react-intl";
import { Icon } from "@progress/kendo-react-common";
import {
  DropDownList,
  DropDownListChangeEvent,
} from "@progress/kendo-react-dropdowns";
import { Utils } from "../../utils/utils";
import Account from "../../utils/apiConfig";
import { Dialog } from "@progress/kendo-react-dialogs";
import ErrorHandler from "../../utils/errorConfig";

export interface CoursesProps {}

export function Course(props: CoursesProps) {
  const intl = useIntl();
  const utils = new Utils();

  const accountInstance = Account.getInstance();
  const errorInstance = ErrorHandler.getErrorInstance();

  const filterOptions = [
    intl.formatMessage({ id: "courses.courseCard.status.Draft" }), // "Draft"
    intl.formatMessage({ id: "courses.courseCard.status.Published" }), // "Published"
    intl.formatMessage({ id: "courses.courseCard.status.InProgress" }), // "In Progress"
    intl.formatMessage({ id: "courses.courseCard.status.InReview" }), // "In Review"
    intl.formatMessage({ id: "courses.courseCard.status.Archived" }), // "Archived"
    intl.formatMessage({ id: "courses.status.all" }), // "All"
  ];

  const options = [
    {
      icon: (
        <FontAwesomeIcon
          icon={["far", "pencil" as IconName]}
          className="fa-fa w-4 h-4 text-mk-primary-bright"
          color="gray"
        />
      ),
      label: intl.formatMessage({ id: "courses.courseCard.renameLabel" }),
      value: "rename",
    },
    {
      icon: (
        <FontAwesomeIcon
          icon={["far", "copy" as IconName]}
          className="fa-fw w-4 h-4 text-mk-primary-bright"
          color="gray"
        />
      ),
      label: intl.formatMessage({ id: "courses.courseCard.duplicateLabel" }),
      value: "duplicate",
    },
    {
      icon: (
        <FontAwesomeIcon
          icon={["far", "fa-pause" as IconName]}
          className="fa-fa w-4 h-4 text-mk-primary-bright"
          color="gray"
        />
      ),
      label: intl.formatMessage({ id: "courses.courseStatus.PauseLabel" }),
      value: "pause",
    },
    {
      icon: (
        <FontAwesomeIcon
          icon={["far", "trash-can" as IconName]}
          className="fa-fa w-4 h-4 text-mk-primary-bright"
          color="gray"
        />
      ),
      label: intl.formatMessage({ id: "courses.courseStattus.DeleteLabel" }),
      value: "delete",
    },
  ];

  const data = [
    {
      icon: "manualCourse.png",
      iconDescription: `${intl.formatMessage({
        id: "courses.model.options.manual",
      })}`,
      disabled: false,
    },
    {
      icon: "generativeAiCourse.png",
      iconDescription: `${intl.formatMessage({
        id: "courses.model.options.generativeAi",
      })}`,
      disabled: false,
    },
    {
      icon: "generativeAiFileCourse.png",
      iconDescription: `${intl.formatMessage({
        id: "courses.model.options.generativeAiFromFile",
      })}`,
      disabled: false,
    },
    {
      icon: "catologueCourse.png",
      iconDescription: `${intl.formatMessage({
        id: "courses.model.options.fromCatalogue",
      })}`,
      disabled: true,
    },
  ];

  const navigate = useNavigate();

  const [warningDialog, setWarningDialog] = useState<boolean>(false);

  //error
  const [errorFlag, setErrorFlag] = useState<boolean>(false);

  const toggleWarningDialog = () => {
    setWarningDialog(!warningDialog);
  };

  const EMPTY_VALUE = "";
  const [visible, setVisible] = useState<boolean>(false);
  const [filterValue, setFilterValue] = useState<string>(
    intl.formatMessage({
      id: "courses.status.all",
    })
  );

  console.log("filter value outside print", filterValue);
  const [allCourses, setAllcourses] = useState<AllCourses>({
    resources: [{} as CoursesRecieved],
  } as AllCourses);
  const [srchCrs, setSrchCrs] = useState<AllCourses>({} as AllCourses);
  console.log("course list print", allCourses);
  const [searchValue, setSearchValue] = useState<string>("");
  const applySearchAndFilter = (searchTerm: string, filter: string) => {
    let courses = utils.deepCopy(srchCrs) as AllCourses;

    const statusFilter = filter.toUpperCase().replace(" ", "");
    if (statusFilter !== "ALL") {
      console.log("I am inside filter status", statusFilter);
      courses.resources = courses.resources.filter((course) => {
        switch (statusFilter) {
          case "DRAFT":
            return course.status === "DRAFT";
          case "PUBLISHED":
            return course.status === "PUBLISHED";
          case "INPROGRESS":
            return course.status === "INPROGRESS";
          case "INREVIEW":
            return course.status === "INREVIEW";
          case "ARCHIVED":
            return course.status === "ARCHIVED";
          default:
            return true;
        }
      });
    } else if (statusFilter === "ALL") {
      courses.resources = courses.resources.filter(
        (course) => course.status !== "ARCHIVED"
      );
    }

    //apply search filter
    console.log("print search term value", searchTerm);
    if (searchTerm) {
      console.log("i entered search term", searchTerm);
      searchTerm = searchTerm.toLowerCase();
      courses.resources = courses.resources.filter((course) =>
        course.courseName.toLowerCase().includes(searchTerm)
      );
    }
    //apply status filter

    courses.resourceCount = courses.resources.length;
    setAllcourses(courses);
  };
  const handleClear = () => {
    setSearchValue(EMPTY_VALUE);

    if (filterValue === "ALL") {
      let courses = utils.deepCopy(srchCrs) as AllCourses;
      courses.resources = courses.resources.filter(
        (course) => course.status !== "ARCHIVED"
      );
      setAllcourses(courses);
      return;
    }
    applySearchAndFilter("", filterValue);
  };

  const goToCreateCourse = (e: string) => {
    navigate("/createCourse", { state: e });
  };

  const handleFilter = (e: DropDownListChangeEvent) => {
    const newFilterValue = e.value.toString();
    setFilterValue(newFilterValue);
    applySearchAndFilter(searchValue?.toString() || "", newFilterValue);
  };

  const handleSearchValueChange = (e: TextBoxChangeEvent) => {
    const newSearchValue = e.value?.toString() || "";
    setSearchValue(newSearchValue);
    applySearchAndFilter(newSearchValue, filterValue);
  };

  const resetFilter = () => {
    setFilterValue(intl.formatMessage({ id: "courses.status.all" }));
  };

  const apiGetCourse = () => {
    resetFilter();
    console.log("filter value print in course admin", filterValue);
    let api = ApiServices.getInstance();
    if (accountInstance.accntId) {
      // if (accId) {
      api
        .makeRequest(`${accountInstance.accntId}/course`, "GET")
        .then(async (res) => {
          if (res && res.errorMessage) {
            setErrorFlag(true);
            await errorInstance.updateErrorCode(res.errorMessage);
            return;
          }
          console.log("Courses", res);
          let x = res as AllCourses;
          x.resources.sort(
            (a, b) =>
              new Date(b.updatedAt!!).getTime() -
              new Date(a.updatedAt!!).getTime()
          );
          setAllcourses(x);
          setSrchCrs(utils.deepCopy(x));
        });
    }
  };

  useEffect(() => {
    apiGetCourse();
  }, []);

  return (
    <div className="w-full h-full flex flex-col items-center space-x-4 justify-evenly">
      {visible && (
        <CreateModal
          description={intl.formatMessage({ id: "courses.modal.description" })}
          successText={intl.formatMessage({ id: "courses.modal.successText" })}
          onCancel={() => setVisible(false)}
          onSuccess={(e: string) => goToCreateCourse(e)}
          data={data}
        />
      )}

      <div className="w-full space-y-4 pb-11">
        <div className="font-bold text-mk-primary-bright text-xl">
          <FormattedMessage id="courses.starterPack" />
        </div>
        <div className="w-full flex space-x-7 w-[100%] h-[60%]">
          <div
            onClick={() => setVisible(true)}
            className="bg-mk-primary-bright hover:cursor-pointer 2xl:w-64 2xl:h-48 xl:w-60 xl:h-44 shadow-xl space-y-4 flex flex-col rounded-xl justify-center items-center"
          >
            <div className="flex items-center justify-center bg-white rounded-[10%] w-5 h-5 text-center font-bold">
              <FontAwesomeIcon
                icon={["fas", "fa-plus" as IconName]}
                className="fa-fw text-mk-primary-bright w-4 h-4"
              />
            </div>

            <div className="2xl:text-2xl xl:text-xl w-44 font-bold text-white text-center">
              <FormattedMessage id="courses.newCourse" />
            </div>
          </div>

          <div className="bg-mk-blue 2xl:w-64 2xl:h-48 xl:w-60 xl:h-44 shadow-xl space-y-4 flex flex-col rounded-xl justify-between items-center">
            <div className="flex 2xl:text-2xl xl:text-xl font-bold text-center w-[70%] xl:pt-10 pt-6">
              <FormattedMessage id="courses.learnMikros" />
            </div>
            <div className="w-full flex px-2 justify-between items-center pb-2">
              <div className="text-shadow 2xl:w-20 xl:w-16 text-start text-black 2xl:text-base xl:text-sm">
                <FormattedMessage id="courses.learnMikros.chaptersAndCards" />
              </div>
              <div className="rounded-full hover:cursor-pointer w-6 h-6 flex justify-center items-center bg-white">
                <MenuOptions options={options} onSelect={(data: any) => {}}>
                  <FontAwesomeIcon
                    icon={["far", "fa-ellipsis" as IconName]}
                    className="fa-fw "
                    color="black"
                  />
                </MenuOptions>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="w-full flex justify-between items-center">
        <TextBox
          value={searchValue}
          onChange={handleSearchValueChange}
          placeholder="Search"
          suffix={() => (
            <>
              {searchValue !== EMPTY_VALUE && (
                <InputClearValue onClick={handleClear}>
                  <Icon name="x" />
                </InputClearValue>
              )}
            </>
          )}
          className="w-[45%] rounded-xl"
        />
        <div className="flex space-x-4 items-center justify-center">
          <DropDownList
            data={filterOptions}
            // defaultValue={"All"}
            value={filterValue}
            defaultValue={`${intl.formatMessage({ id: "courses.status.all" })}`}
            className="w-40 text-sm"
            onChange={handleFilter}
          />
        </div>
      </div>

      <div className="pb-8"></div>
      {/* 
      <div className="w-full space-y-4 pb-5">
        <div className="w-full h-full justify-between grid gap-y-10 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-3 xl:grid-cols-4 2xl:grid-cols-5 md:gap-12 pb-[5%]">
          {errorFlag && (
            <Dialog className="errorDialogue">
              <Alert
                description={intl.formatMessage({
                  id: errorInstance.errorCode,
                })}
                buttonText={`${intl.formatMessage({
                  id: "users.buttonText.Ok",
                })}`}
                icon={"errorShape.png"}
                iconMsg={intl.formatMessage({
                  id: "iconMsgError",
                })}
                backgroundColor={"mk-red"}
                onClick={() => {
                  setErrorFlag(false);
                  navigate("/courses");
                }}
              />
            </Dialog>
          )}
          {allCourses.resources
            ?.filter((course) => {
              // if (filterValue === "All") {
              if (
                filterValue ===
                intl.formatMessage({
                  id: "courses.status.all",
                })
              ) {
                return course.status !== "ARCHIVED";
              }
              return true;
            })
            // allCourses.resources?
            .map((ele, i) => {
              return (
                <CourseCard
                  key={ele.courseId}
                  backGroundImage={ele.thumbnailUrl!!}
                  handleGoToCourse={(chptId: string) => {
                    navigate("/editCourse", {
                      state: JSON.stringify({
                        name: `${intl.formatMessage({
                          id: "courses.editCourse",
                        })}`,
                        data: chptId,
                      }),
                    });
                  }}
                  courseDetail={ele}
                  onReload={() => {
                    apiGetCourse();
                  }}
                />
              );
            })}
        </div>
      </div> */}

      <div className="w-full space-y-4 pb-5">
        {allCourses.resources?.some((course) =>
          filterValue === intl.formatMessage({ id: "courses.status.all" })
            ? course.status !== "ARCHIVED"
            : true
        ) ? (
          <div className="w-full h-full justify-between grid gap-y-10 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-3 xl:grid-cols-4 2xl:grid-cols-5 md:gap-12 pb-[5%]">
            {allCourses.resources
              ?.filter((course) => {
                if (
                  filterValue ===
                  intl.formatMessage({ id: "courses.status.all" })
                ) {
                  return course.status !== "ARCHIVED";
                }
                return true;
              })
              .map((ele, i) => (
                <CourseCard
                  key={ele.courseId}
                  backGroundImage={ele.thumbnailUrl!!}
                  handleGoToCourse={(chptId: string) => {
                    navigate("/editCourse", {
                      state: JSON.stringify({
                        name: intl.formatMessage({ id: "courses.editCourse" }),
                        data: chptId,
                      }),
                    });
                  }}
                  courseDetail={ele}
                  onReload={() => {
                    apiGetCourse();
                  }}
                />
              ))}
          </div>
        ) : (
          <div className="w-full h-full flex items-center justify-center text-center text-lg text-mk-primary-bright font-semibold mt-4">
            {intl.formatMessage({
              id: "courses.noCourseMatch",
            })}
          </div>
        )}
      </div>
    </div>
  );
}
